var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.05806 4.55806C5.30214 4.31398 5.69786 4.31398 5.94194 4.55806L10.5 9.11612L15.0581 4.55806C15.3021 4.31398 15.6979 4.31398 15.9419 4.55806C16.186 4.80214 16.186 5.19786 15.9419 5.44194L11.3839 10L15.9419 14.5581C16.186 14.8021 16.186 15.1979 15.9419 15.4419C15.6979 15.686 15.3021 15.686 15.0581 15.4419L10.5 10.8839L5.94194 15.4419C5.69786 15.686 5.30214 15.686 5.05806 15.4419C4.81398 15.1979 4.81398 14.8021 5.05806 14.5581L9.61612 10L5.05806 5.44194C4.81398 5.19786 4.81398 4.80214 5.05806 4.55806Z",
  fill: "#00538F"
});

function SvgXFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXFill);
export default __webpack_public_path__ + "static/media/x-fill.38980749.svg";
export { ForwardRef as ReactComponent };